import React from 'react'

interface ChevronDownIconProps {
    className?: string
}

const ChevronDownIcon = ({ className }: ChevronDownIconProps) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9" />
    </svg>
)

export default ChevronDownIcon
